import { t } from '@avalara/bat-apps-shared/i18n';
import AlreadyHaveAccount from '../../already-have-account';

const CompanySetupText = () => (
  <>
    <p>{t('client.general.this-is-the-start-of-the-company-profile-we-use-to-calculate')}</p>
    <p className='pad-top-sm pad-bottom-md'>
      <span>
        <AlreadyHaveAccount />
      </span>
    </p>
  </>
);

export default CompanySetupText;
